import React from 'react';
import './PersonalRecordsGrid.css';

// `records` is playerProgressService.computePersonalRecords' own output —
// each entry only exists when real historical evidence supports it (see
// that function's comment); this component never invents a placeholder for
// a missing record, it simply doesn't render one.
const PersonalRecordsGrid = ({ records }) => {
  if (!records || records.length === 0) {
    return (
      <div className="z-card pr-empty">
        No personal records yet — complete a challenge or assessment to set your first one.
      </div>
    );
  }

  return (
    <div className="pr-grid">
      {records.map(r => (
        <div key={r.id} className="pr-card">
          <span className="pr-value">{r.value}</span>
          <span className="pr-label">{r.label}</span>
          <span className="pr-context">{r.context}</span>
        </div>
      ))}
    </div>
  );
};

export default PersonalRecordsGrid;
